import axios from 'axios';
import { logout } from './userActions';

export const getDashboardDataInitials = () => async (dispatch) => {
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json'
			}
		};

		const { data } = await axios.get(`/api/dashboard`, config);

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			dispatch(logout());
		} else {
			return {};
		}
	} catch (err) {
		return {};
	}
};

export const getDashboardData = (formData = null) => async (dispatch) => {
	try {
		let response;
		
		if (formData) {
			// POST request with watcher filter
			response = await axios.post(`/api/dashboard`, formData);
		} else {
			// GET request for initial data (all watchers)
			const config = {
				headers: {
					'Content-Type': 'application/json'
				}
			};
			response = await axios.get(`/api/dashboard`, config);
		}

		const { data } = response;

		if (data && data.status) {
			return data;
		} else if (data && !data.status) {
			dispatch(logout());
		} else {
			return {};
		}
	} catch (err) {
		console.error('Error in getDashboardData:', err);
		return {};
	}
};
